import lottie from "lottie-web";

class IllustrationFooter extends HTMLElement {
  constructor() {
    super();
    this.hejAnimation = null;
    this.kiteAnimation = null;
    this.yogaRightAnimation = null;
    this.yogaLeftAnimation = null;
    this.observer = null;
  }

  connectedCallback() {
    this.hejContainer = this.hejContainer || this.querySelector(".hej-container");
    this.kiteContainer = this.kiteContainer || this.querySelector(".kite-container");
    this.yogaContainer = this.yogaContainer || this.querySelector(".yoga-left-container");
    this.yogaContainer = this.yogaContainer || this.querySelector(".yoga-Right-container");

    this.hejAnimation = lottie.loadAnimation({
      container: this.hejContainer,
      path: "/dist/lottie/Hej(x10).json",
      renderer: "svg",
      loop: false,
      autoplay: false,
      name: "Talebobbel med hej",
    });

    this.kiteAnimation = lottie.loadAnimation({
      container: this.querySelector(".kite-container"),
      path: "/dist/lottie/kites(x10).json",
      renderer: "svg",
      loop: true,
      autoplay: true,
      name: "Personer der flyver med drager",
    });

    this.yogaRightAnimation = lottie.loadAnimation({
      container: this.querySelector(".yoga-right-container"),
      path: "/dist/lottie/yoga-pose1(x10).json",
      renderer: "svg",
      loop: true,
      autoplay: true,
      name: "Person der laver yoga",
    });

    this.yogaLeftAnimation = lottie.loadAnimation({
      container: this.querySelector(".yoga-left-container"),
      path: "/dist/lottie/yoga-pose2(x10).json",
      renderer: "svg",
      loop: true,
      autoplay: true,
      name: "Person der laver yoga",
    });

    this.initObserver();
  }

  initObserver() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.4,
    };

    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Play the animation when the hejContainer element enters the frame
          if (entry.target === this.hejContainer) {
            this.hejAnimation.goToAndPlay(0, true);
          }
        } else {
          // Stop the hejContainer animation when the element leaves the frame
          if (entry.target === this.hejContainer) {
            this.hejAnimation.stop();
          }
        }
      });
    }, options);

    this.observer.observe(this.hejContainer);
    this.kiteAnimation.play();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define("nabohjaelp-illustration-footer", IllustrationFooter);
